// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6159162a","507":"8597e4b8","553":"56a2a834"}[chunkId] + ".chunk.js";
};